const newsletterTrigger = document.querySelector(".js-newsletter-trigger");

if (typeof newsletterTrigger != "undefined" && newsletterTrigger != null) {

    const newsletter = document.querySelector(".js-newsletter-wrapper");
    const activeClass = "is-active";

    function toggleNewsletter(){
        newsletterTrigger.classList.toggle(activeClass)
        newsletter.classList.toggle(activeClass);
    }

    newsletterTrigger.addEventListener('click', toggleNewsletter);



}